import React from "react";

import { Grid, Slide } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import styled from "styled-components/macro";
import { useSelector } from "react-redux";

import { TemporaryBusinessWarnings } from "components/DeploymentSaleSummaries/TemporaryBusinessWarnings";
import { MediumMobileCard } from "components/SaleSummaryCards/Cards";
import { CompactCardStack } from "components/SaleSummaryCards/Common";
import { TitleText } from "components/Text";

import { SaleType } from "constants/sale";

import { ForNotHooks } from "containers/ForSaleType";

import { getEffectiveSaleTitleBySaleId } from "selectors/sales";
import { dateTimeStringToDateTime, formatDateString } from "lib/timeFormats";

import { PrivateSaleExceptionsComponent } from "./ExceptionsTable";
import { ReviewCard, ReviewField } from "components/ReviewCard";

const SummaryGrid = styled(Grid)`
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const ReviewCardsSection = styled.div`
  padding: ${({ theme }) => theme.space[2]}px;
`;

export const PrivateSaleOverview = ({
  sale,
  notes,
  buyerName,
  vendorName,
  product,
  breed,
  carrierName,
  quantity,
  deploymentSales,
}) => {
  const saleId = sale?.livestocksale_id ?? sale?.id;
  const effectiveTitle = useSelector(getEffectiveSaleTitleBySaleId(saleId));

  return (
    <Slide in direction="right">
      <SummaryGrid container justifyContent="space-evenly">
        <Grid item xs={12}>
          <TitleText center block>
            {effectiveTitle}
          </TitleText>
        </Grid>
        <Grid item container xs={12} justifyContent="center">
          <Container disableGutters>
            <CompactCardStack>
              <MediumMobileCard
                title={
                  sale.sale_type === SaleType.OVER_HOOKS
                    ? "Sale/Kill Date"
                    : "Sale Date"
                }
                value={
                  sale.date
                    ? formatDateString(dateTimeStringToDateTime(sale.date))
                    : "-"
                }
              />
              <ForNotHooks>
                <MediumMobileCard title="Vendor" value={vendorName} />
              </ForNotHooks>
              <MediumMobileCard title="Buyer" value={buyerName} />
              <MediumMobileCard title="Head" value={quantity} />
              <MediumMobileCard title="Description" value={product} />
              <MediumMobileCard title="Breed" value={breed} />
              <MediumMobileCard title="Carrier" value={carrierName} />
            </CompactCardStack>
          </Container>
        </Grid>

        <Grid container spacing={2} style={{ margin: 0 }}>
          {/* TODO: Make this button work */}
          {/* <Grid item xs={12}>
            <IconButton icon={faCheck} fullWidth disabled data-tour="confirm">
              Confirm
            </IconButton>
          </Grid> */}
        </Grid>
        <Grid item xs={12}>
          <ReviewCardsSection>
            {notes && (
              <ReviewCard>
                <ReviewField>{notes}</ReviewField>
              </ReviewCard>
            )}
          </ReviewCardsSection>
        </Grid>
        {deploymentSales.map(deploymentSale => (
          <PrivateSaleExceptionsComponent
            key={deploymentSale?.deployment_sale_id}
            deploymentSaleId={deploymentSale?.deployment_sale_id}
          />
        ))}
        <Grid item container xs={12} justifyContent="center">
          <Container disableGutters>
            <TemporaryBusinessWarnings />
          </Container>
        </Grid>
      </SummaryGrid>
    </Slide>
  );
};
